import React, { useEffect, useRef } from 'react';

interface AdsterraNativeBannerProps {
  className?: string;
  showHeading?: boolean;
}

export const AdsterraNativeBanner: React.FC<AdsterraNativeBannerProps> = ({
  className = '',
  showHeading = true,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Check if script already appended to this container
    if (container.querySelector('script[src*="d03485b485114a8f898285c0fc897bf6"]')) {
      return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.setAttribute('data-cfasync', 'false');
    script.src = 'https://pl31514081.profitableratecpmnetwork.com/d03485b485114a8f898285c0fc897bf6/invoke.js';
    script.onerror = () => {
      // Gracefully handle ad blocker or network failure
    };

    container.appendChild(script);

    return () => {
      if (container && container.contains(script)) {
        container.removeChild(script);
      }
    };
  }, []);

  return (
    <section
      aria-label="Sponsored Recommendations"
      className={`mx-auto max-w-7xl px-4 py-4 md:py-6 ${className}`}
    >
      {showHeading && (
        <div className="mb-3 flex items-center justify-between">
          <div>
            <h3 className="font-heading text-lg font-bold text-foreground md:text-xl">
              Sponsored Recommendations
            </h3>
            <p className="text-xs text-muted-foreground">Special recommendations and partner promotions</p>
          </div>
          <span className="text-[10px] tracking-wider uppercase bg-slate-100 text-slate-500 font-semibold px-2 py-0.5 rounded">
            Ad
          </span>
        </div>
      )}
      <div className="w-full min-h-[120px] overflow-hidden rounded-2xl border border-border/80 bg-card p-3 shadow-xs">
        <div ref={containerRef} className="w-full flex flex-col items-center justify-center">
          <div id="container-d03485b485114a8f898285c0fc897bf6" className="w-full min-h-[100px]" />
        </div>
      </div>
    </section>
  );
};

export default AdsterraNativeBanner;
